import api from '../utils/api';

class UserApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/users', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  create = (data) => {
    return new Promise((resolve, reject) => {
      return api
        .post('/v1/admin/user', data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  update = (id, data) => {
    return new Promise((resolve, reject) => {
      return api
        .put(`/v1/admin/user/${id}`, data)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  delete = (id) => {
    return new Promise((resolve, reject) => {
      return api
        .post(`/v1/admin/user/${id}/anonymize`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  /**
   * Original hard delete endpoint
   * 
  deleteHard = (id) => {
    return new Promise((resolve, reject) => {
      return api
        .delete(`/v1/admin/user/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  */

  resetPassword = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.post('/user/resetpassword', data);
        resolve(true);
      } catch (err) {
        reject(err);
      }
    });
  };

  getDetail = (id) => {
    return new Promise((resolve, reject) => {
      return api
        .get(`/v1/admin/user/${id}`)
        .then((res) => {
          resolve(res.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  getAllUsers = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/users', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDashboard = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/user/dashboard', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getSignupStatsByCountry = (countryId, params = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get(`/v1/admin/user/signup-stats/by-country/${countryId}`, { params });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getSignupCountsByCountry = (params = {}) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/user/signup-stats/by-country', { params });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getDashboardContents = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/dashboard/contents', { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getInterestUserCounts = () => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api.get('/v1/admin/buyer/interest-user-counts', { params: { scope: 'admin-dashboard' } });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}

const userApi = new UserApi();
export default userApi;
